export const NAME = 'subsellerSearch';
export const dialogError = `${NAME}/requiredFields`;
